import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "star-picker-container" }
const _hoisted_2 = ["onMouseenter", "onClick"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  width: "24",
  height: "24"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11.5245 4.46353C11.6741 4.00287 12.3259 4.00287 12.4755 4.46353L13.9084 8.87336C13.9753 9.07937 14.1673 9.21885 14.3839 9.21885H19.0207C19.505 9.21885 19.7064 9.83866 19.3146 10.1234L15.5633 12.8488C15.3881 12.9761 15.3148 13.2018 15.3817 13.4078L16.8145 17.8176C16.9642 18.2783 16.437 18.6613 16.0451 18.3766L12.2939 15.6512C12.1186 15.5239 11.8814 15.5239 11.7061 15.6512L7.95488 18.3766C7.56303 18.6613 7.03578 18.2783 7.18546 17.8176L8.6183 13.4078C8.68524 13.2018 8.61191 12.9761 8.43667 12.8488L4.68544 10.1234C4.29358 9.83866 4.49497 9.21885 4.97933 9.21885H9.6161C9.83272 9.21885 10.0247 9.07937 10.0916 8.87336L11.5245 4.46353Z",
  stroke: "#ffe018",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]

import { ref } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'starPicker',
  props: {
    maxQuantity: {},
    pickedQuantity: {}
  },
  emits: ["update:pickedQuantity"],
  setup(__props: any, { emit: __emit }) {


const props = __props

const emits = __emit

const hoveredStar = ref<number | null>(null)

const updatePickedQuantity = (value: number) => {
    emits('update:pickedQuantity', value)
}

const handleMouseEnter = (starIndex: number) => {
    hoveredStar.value = starIndex - 1 // Convert to 0-based index
}

const handleMouseLeave = () => {
    hoveredStar.value = null
}

const handleStarClick = (starIndex: number) => {
    updatePickedQuantity(starIndex) // Keep 1-based for the prop
}

const shouldFillStar = (starIndex: number) => {
    const zeroBasedIndex = starIndex - 1
    const targetIndex = hoveredStar.value !== null ? hoveredStar.value : props.pickedQuantity - 1
    return zeroBasedIndex <= targetIndex
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "star-picker-container__stars",
      onMouseleave: handleMouseLeave
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.maxQuantity, (i) => {
        return (_openBlock(), _createElementBlock("svg", {
          key: i,
          width: "24px",
          height: "24px",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          class: _normalizeClass(["star-svg", { 'star-filled': shouldFillStar(i) }]),
          onMouseenter: ($event: any) => (handleMouseEnter(i)),
          onClick: ($event: any) => (handleStarClick(i))
        }, _hoisted_5, 42, _hoisted_2))
      }), 128))
    ], 32)
  ]))
}
}

})